import { AccountSettingServicesUpdate } from "./AccountSettingServices.route";
import { put ,get ,post } from "../index";

const AccountSettingServices = {
    updatePassword: async (obj) => {
    let result = await put(AccountSettingServicesUpdate.updatePassword, obj);
    return result;
  },
    forgotPassword: async (obj) => {
    let result = await put(AccountSettingServicesUpdate.forgotPassword, obj);
    return result;
  },
    checkLog: async (month ,year ,userId) => {
    let result = await get(AccountSettingServicesUpdate.checkLog + `?month=${month}&year=${year}&user_id=${userId}`);
    return result;
  },
    getAllAttendance: async (month ,year) => {
    let result = await get(AccountSettingServicesUpdate.getAllAttendance + `?month=${month}&year=${year}`);
    return result;
  },
    markAttendance: async (obj) => {
    let result = await post(AccountSettingServicesUpdate.markAttendance , obj);
    return result;
  },
    updateAttendance: async (obj) => {
    let result = await post(AccountSettingServicesUpdate.updateAttendance , obj);
    return result;
  },
    checkAttendanceStatus: async (obj) => {
    let result = await get(AccountSettingServicesUpdate.checkAttendanceStatus);
    return result;
  },
};

export default AccountSettingServices;  
